import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import SiteMap from './SiteMap'

import LogoSVG from '../images/logo.svg'

const Wrapper = styled.footer`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 auto;
  max-width: ${props => props.theme.sizes.maxWidth};
  border-top: solid 2px ${props => props.theme.colors.base};
`

const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
  padding: 1em 0 2em;
  margin: 0 1.5em;
  align-items: center;
`

const Item = styled.li`
  display: inline-block;
  padding: 0.25em 0;
  width: 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    width: auto;
  }
  a {
    font-weight: 600;
    transition: all 0.2s;
    color: ${props => props.theme.colors.base};
    &:hover {
      color: ${props => props.theme.colors.highlight};
    }
    &:visited {
      color: ${props => props.theme.colors.base};
    }
  }
`

const Footer = () => (
  <Wrapper>
    <List>
      <Item>
        <Link to="/">
          <img src={LogoSVG} style={{ width: '150px' }} alt="Logo" />
        </Link>
      </Item>
      <Item>
        <p style={{ opacity: 0.5 }}>
          &copy; Young Lives – {new Date().getFullYear()}
        </p>
      </Item>
      <Item>
        <SiteMap />
      </Item>
    </List>
  </Wrapper>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js